import { Alert as AntAlert } from 'antd'
import styled from 'styled-components'

const AntAlertContainer = styled(AntAlert)`
  margin-bottom: 15px;
  .ant-alert-message {
    color: #9b0d03;
  }
`

const Alert = ({ children, type, ...rest }) => {
  return <AntAlertContainer {...rest} type={type} />
}

export default Alert
